import { useBaseViewModel } from '@/common';
import {
  QueryCourseLinePayload,
  QueryCourseLinesOutput,
} from '@/domains/course-lines/ports/payloads';
import { GetListCourseLineUsecase } from '@/domains/course-lines/usecases';
import { useState } from 'react';
import { CourseLineHttpRepository } from '../adapters/repositories';

export default function GetListCourseLine() {
  const getListCourseLineUC = new GetListCourseLineUsecase(new CourseLineHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseLineData, setCourseLineData] = useState<QueryCourseLinesOutput>();

  const actionGetAllCourseLine = async (payload?: QueryCourseLinePayload) => {
    await catchAction(async () => {
      const data = await getListCourseLineUC.run(payload);
      setCourseLineData(data);
    });
  };

  return {
    loading,
    error,
    courseLineData,
    actionGetAllCourseLine,
  };
}
